// Cmd+Enter (Ctrl+Enter off macOS) submits the form around the focused field,
// as it does in the app.
//
// It presses the form's submit button rather than calling requestSubmit()
// on the form, so the button's own formaction and its confirmation
// (rails-ujs `data-confirm`, which hooks the click) apply. A form with
// several submit buttons is left alone: which one Cmd+Enter means is the
// form's own business (the admin broadcast form has "Send test" and "Send
// broadcast"; the face labeler has a button per destination), and picking
// the first would send the wrong one. A form with no submit button falls
// back to requestSubmit, so Turbo, Stimulus submit actions and native
// validation still see an ordinary submit.
//
// No Turbo or Stimulus here: layouts/public_card loads this directly and
// ships no Turbo on purpose (see story.js).
document.addEventListener("keydown", (event) => {
  if (event.key !== "Enter" || !(event.metaKey || event.ctrlKey) || event.isComposing || event.repeat) return

  const form = event.target.form
  if (!form) return

  const buttons = form.querySelectorAll("button:not([type]), button[type=submit], input[type=submit]")
  if (buttons.length > 1) return

  event.preventDefault()
  if (buttons.length === 1 && !buttons[0].disabled) buttons[0].click()
  else if (buttons.length === 0) form.requestSubmit()
})
